import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import SvgIcon from '@mui/material/SvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ComposeIcon = function ComposeIcon(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({
    viewBox: "0 0 500 500"
  }, props), {}, {
    "data-element": "SvgIcon",
    "data-component": "ComposeIcon",
    "data-source-file": "compose.tsx",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M146.5,304.6v42.7c0,4,3.1,7.1,7.1,7.1h42.7c1.9,0,3.8-0.6,5-2.1l184.4-184.2l-52.5-52.5l-184.6,184  C147.1,301,146.5,302.7,146.5,304.6z M433.3,119.8c5.4-5.4,5.4-14.4,0-19.8l-32.9-32.9c-5.4-5.4-14.4-5.4-19.8,0l-25.8,25.8  l52.7,52.7C407.5,145.6,433.3,119.8,433.3,119.8z",
      "data-element": "path",
      "data-component": "ComposeIcon",
      "data-source-file": "compose.tsx"
    }), /*#__PURE__*/_jsx("path", {
      d: "M437.5,229.1v166.7c0,11.5-4.6,21.9-12.3,29.4c-7.5,7.7-17.9,12.3-29.4,12.3H104.2c-22.9,0-41.7-18.7-41.7-41.7V104.1  c0-11.5,4.6-21.9,12.3-29.4c7.5-7.7,17.9-12.3,29.4-12.3h166.7c11.5,0,20.8,9.4,20.8,20.8s-9.4,20.8-20.8,20.8H104.2v291.7h291.7  V229.1c0-11.5,9.4-20.8,20.8-20.8S437.5,217.7,437.5,229.1z",
      "data-element": "path",
      "data-source-file": "compose.tsx"
    })]
  }));
};